import StringConst from "../../StringConst";

export const FinancialChangeFunction = (event, id, financialSearch) => {
    for (let i = 0; i < financialSearch.length; i++) {
        if (id === financialSearch[i].id) {
            financialSearch[i].weight = event.target.value
        }
    }
    return financialSearch;
}

export const validateRiskGrades = (riskGradesData) => {
    let flag = false;
    if (!riskGradesData) {
        return false
    } else {
        for (let i = 0; i < riskGradesData.length; i++) {
            if (riskGradesData[i].minScore && riskGradesData[i].maxScore && riskGradesData[i].riskGrade && riskGradesData[i].gradeDescription) {
                flag = true;
            } else {
                flag = false;
            }
        }
        return flag;
    }
}
const validateFinancialRisk = (financialData) => {
    let tempFlag = false;
    financialData.forEach((element) => {
        if (element.value && element.weight) {
            tempFlag = true;
        } else {
            return false;
        }
    })
    return tempFlag;
}
const validateNonFinancialRisk = (nonFinancialData) => {
    let tempFlag = false;
    nonFinancialData.forEach((element) => {
        if (element.value && element.weight) {
            tempFlag = true;
        } else {
            return false;
        }
    })
    return tempFlag;
}
export const validateScorecardForm = (scorecardFormData) => {
    if (!scorecardFormData) {
        return false;
    }
    if (scorecardFormData.scorecardName && scorecardFormData.corporateName && scorecardFormData.counterPartyType) {
        return true
    } else {
        return false
    }

}
export const validateRisk = (financialData, nonFinancialData) => {
    let financialFlag = false, nonfinancialFlag = false;
    if (financialData) {
        financialFlag = validateFinancialRisk(financialData);
    } else {
        financialFlag = false
    }

    if (nonFinancialData) {
        nonfinancialFlag = validateNonFinancialRisk(nonFinancialData);
    } else {
        nonfinancialFlag = false
    }

    // overriddenFlag = validateOverriddenRisk(overriddenData);
    if (financialFlag && nonfinancialFlag) {
        return true;
    } else {
        return false;
    }

}
const riskFinancialBody = (financialData) => {
    let temp = [];
    financialData.forEach((element) => {
        temp.push({
            riskFactorId: element.id,
            riskFactorName: element.value,
            assignedWeight: element.weight,
            displayNameType: StringConst.SECTION_TYPE_FINANCIAL
        })
    })
    return temp;
}
const riskNonFinancialBody = (nonFinancialData) => {
    let temp = [];
    nonFinancialData.forEach((element) => {
        temp.push({
            riskFactorId: element.id,
            riskFactorName: element.value,
            assignedWeight: element.weight,
            displayNameType: 'NON_FINANCIAL'
        });
    })
    return temp;
}
export const riskFactorBody = (financialData, nonFinancialData) => {
    const riskFactorBodyData = [...riskFinancialBody(financialData), ...riskNonFinancialBody(nonFinancialData)]
    return riskFactorBodyData;
}

export const editFinancialRiskFactors = (financialRiskData) => {
    let financialData = [];
    financialRiskData.riskfactors.forEach((element) => {
        if (element.displayNameType === StringConst.SECTION_TYPE_FINANCIAL) {
            financialData.push({
                id: element.riskFactorId,
                value: element.riskFactorName,
                weight: element.assignedWeight
            })
        }
    })
    return financialData;
}
export const editNonFinancialRiskFactors = (NonFinancialRiskData) => {
    let nonFinancialData = [];
    NonFinancialRiskData.riskfactors.forEach((element) => {
        if (element.displayNameType === 'NON_FINANCIAL') {
            nonFinancialData.push({
                id: element.riskFactorId,
                value: element.riskFactorName,
                weight: element.assignedWeight
            })
        }
    })
    return nonFinancialData;
}
export const editOverrideRiskFactors = (OverrideRiskData) => {
    let overideData = [];
    OverrideRiskData.riskfactors.forEach((element) => {
        if (element.displayNameType === 'OVERRIDDEN') {
            overideData.push({
                id: element.riskFactorId,
                value: element.riskFactorName,
                weight: element.assignedWeight
            })
        }
    })
    return overideData;
}
export const deleteRiskFactor = (riskFactorData, id) => {
    const tempRiskFactor = [...riskFactorData]
    tempRiskFactor.forEach((index, item, element) => {
        if (id === index.id) {
            tempRiskFactor.splice(item, 1);
        }
    })
    return tempRiskFactor;
}
export const propsChangeFunction = (financialSearch, nonFinancialSearch, overriddenSearch, prevProps) => {

    if ((financialSearch !== prevProps.financialSearch) || nonFinancialSearch !== prevProps.nonFinancialSearch || overriddenSearch !== prevProps.overriddenSearch) {
        return true;
    } else {
        return false;
    }
}

export const updateFinancialData = (data, searchResult) => {
    let temp = [...data];
    const tempFinancial = {
        id: searchResult.id,
        value: searchResult.value,
        weight: ''
    }
    temp.push(tempFinancial);
    return temp
}

export const checkDuplicateData = (data, searchResult) => {
    let flag = true;
    data.forEach((item, index, element) => {
        if (item.id === searchResult.id) {
            flag = false;
        } 
    })

    return updateDuplicateData(flag, data, searchResult);
}
export const updateDuplicateData = (flag, data, searchResult) => {
    let temp = [...data];
    if (flag) {
        const tempFinancial = {
            id: searchResult.id,
            value: searchResult.value,
            weight: ''
        }
        temp.push(tempFinancial);
    }
    return temp
}